import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import supabase from 'modules/core/supabase/supabase';

export function useFetchLogoBackground() {
  const userTournamentId = useSelector(authStoreUserTournamentId);

  return useQuery({
    queryKey: ['logo-backgrounds', userTournamentId],
    queryFn: () => {
      if (!userTournamentId) return Promise.resolve(null);
      return supabase.organizerLogoBacking.get({ tournamentId: userTournamentId });
    },
    enabled: !!userTournamentId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
